import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "./assets/scss/ads-detail.scss";
import "./assets/scss/create-ads.scss";
import "./assets/scss/dashboard.scss";
import "./assets/scss/product-register.scss";
import "./assets/scss/pincode.scss";
import "./assets/scss/splash.scss";
import VueCookie from "vue-cookies";

Vue.use(VueCookie);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
